import React from 'react'
import styled from '@emotion/styled'
import {SoldOutBodyMessage} from 'components/SearchUnavailability/SoldOut/SoldOutBodyMessage'
import {SoldOutBase} from 'components/Unavailability/SoldOut/SoldOutBase'

import {Button} from '@vio/atlas/Button'
import {ButtonLink} from '@vio/atlas/ButtonLink'
import {Card} from '@vio/atlas/Card'
import {Icon} from '@vio/atlas/Icon'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface UnavailabilityWithPopupTriggerProps {
  handleShowAvailabilityPopup: (e: React.MouseEvent) => void
  handleChangeDatesClick: (e: React.MouseEvent) => void
  showViewPopupCalendar?: boolean
  isLoading?: boolean
}

export const UnavailabilityWrapper = styled(Card)`
  padding: ${cssTheme.layout.spacing.s500};
  width: 100%;
`

const ChangeDatesButton = styled(Button)`
  margin-top: 14px;
`

const ActionButton = ({
  handleShowAvailabilityPopup,
  handleChangeDatesClick,
  showViewPopupCalendar
}: UnavailabilityWithPopupTriggerProps) => {
  if (showViewPopupCalendar) {
    return (
      <ButtonLink
        size="sm"
        isCompact
        iconStart={<Icon name="Calendar" size="sm" />}
        onClick={handleShowAvailabilityPopup}
        dataId="AvailabilityCalendarTrigger"
      >
        <FormattedMessageWrapper
          id="viewCalendar"
          defaultMessage="View calendar"
        />
      </ButtonLink>
    )
  }

  return (
    <ChangeDatesButton
      variant="tertiary"
      fullWidth
      onClick={handleChangeDatesClick}
    >
      <FormattedMessageWrapper id="changeDates" defaultMessage="Change dates" />
    </ChangeDatesButton>
  )
}

export const UnavailabilityWithPopupTrigger = ({
  handleShowAvailabilityPopup,
  handleChangeDatesClick,
  showViewPopupCalendar,
  isLoading
}: UnavailabilityWithPopupTriggerProps) => {
  return (
    <UnavailabilityWrapper
      backgroundColorPath="background.neutral.disabled"
      borderRadius="lg"
    >
      <SoldOutBase
        headerSlot={<SoldOutBodyMessage shouldWrapDates />}
        contentSlot={
          isLoading ? (
            <SkeletonLoader />
          ) : showViewPopupCalendar ? (
            <FormattedMessageWrapper
              id="checkOutAvailableDates"
              defaultMessage="Check out available dates"
            />
          ) : null
        }
        actionSlot={
          isLoading ? (
            <SkeletonLoader marginTop={0} />
          ) : (
            <ActionButton
              handleShowAvailabilityPopup={handleShowAvailabilityPopup}
              handleChangeDatesClick={handleChangeDatesClick}
              showViewPopupCalendar={showViewPopupCalendar}
            />
          )
        }
      />
    </UnavailabilityWrapper>
  )
}
